import { SvgIcon, SvgIconProps } from "@mui/material";

/**
 * Line icons traced from `Inbox Requests.dc.html` that the Sign Requests set
 * doesn't already carry. Everything shared with that screen (document, search,
 * calendar, caret, right chevron, plus-circle) is imported from
 * `components/SignRequestsIcons` instead of being duplicated here.
 *
 * All of them inherit `currentColor`; size comes from the caller's `sx`.
 */

const strokeProps = {
  fill: "none",
  stroke: "currentColor",
  strokeLinecap: "round" as const,
  strokeLinejoin: "round" as const,
};

/** Previous-page arrow in the pager. */
export const ChevronLeftGlyph = (props: SvgIconProps) => (
  <SvgIcon viewBox="0 0 24 24" {...props}>
    <path {...strokeProps} strokeWidth={2.2} d="M15 6l-6 6 6 6" />
  </SvgIcon>
);

/** Open tray — the "Your inbox is empty" mark. */
export const InboxTrayGlyph = (props: SvgIconProps) => (
  <SvgIcon viewBox="0 0 24 24" {...props}>
    <path {...strokeProps} strokeWidth={1.8} d="M22 12h-6l-2 3h-4l-2-3H2" />
    <path
      {...strokeProps}
      strokeWidth={1.8}
      d="M5.5 5.1 2 12v6a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-6l-3.5-6.9A2 2 0 0 0 16.7 4H7.3a2 2 0 0 0-1.8 1.1z"
    />
  </SvgIcon>
);

/** Magnifier with a minus — the "No requests match" mark. */
export const SearchEmptyGlyph = (props: SvgIconProps) => (
  <SvgIcon viewBox="0 0 24 24" {...props}>
    <circle {...strokeProps} strokeWidth={1.9} cx="11" cy="11" r="7" />
    <path {...strokeProps} strokeWidth={1.9} d="m21 21-4.3-4.3" />
    <path {...strokeProps} strokeWidth={1.9} d="M8.5 11h5" />
  </SvgIcon>
);
